import { PPC_CLOSE } from '../../shared-components/ClosePage/ClosePageConstants';

export const SUBMIT_API = 'submitapi';
export const NEW_CUST_API = 'newcustapi';
export const SECCI_SUBMIT_API = 'secciAPI';
export const CA_SUBMIT_API = 'contractAPI';
export const SUBMIT_COMPLETE_API = 'submitCompleteAPI';
export const GB_COUNTRY = 'gb';

export const PAGE_NAME = {
    NEWCUST_PAGE: 'newcust',
    APPLY_PAGE: 'applypage',
    ERROR_PAGE: 'errorpage',
    INELIGIBLE_PAGE: 'ineligible',
    DECISION_PAGE: 'decisionpage',
    CA_PAGE: 'contractpage',
    CLOSE_PAGE: PPC_CLOSE,
    LANDING_PAGE: 'landingpage'
};

export const REDIRECT_SUFFIX = {
    PAY_IN_FULL_REDIRECT: 'payInFullNowFlow',
    CANCEL_REDIRECT: 'cancelFlow',
    LOGIN_REDIRECT: 'loginRedirectFlow'
};

export const LEGACY_ENDPOINT = {
    PAGE_NAME: {
        DECISION: 'decision',
        APPLY: 'apply',
    }
};

export const APPLICATION_STATUS = {
    NEED_SIGNATURE: 'consumerCredit',
    APPROVED: 'APPROVED',
    SOFT_DECLINE: 'SOFT_DECLINED',
    ANS_SOFT_DECLINE: 'ppc_address_normalization_error'
};

export const PPC_STATUS = {
    INELIGIBLE: 'INELIGIBLE'
};

export const GB_PRIVACY_STATEMENT_URL = 'https://www.paypal.com/uk/webapps/mpp/ua/privacy-full';

export const GB_CREDIT_CRAIN_URL = 'https://www.paypal.com/uk/webapps/mpp/credit-crain-terms';

export const GB_MARKETING_TERMS_MORE_INFO_URL = 'https://www.paypal.com/gb/webapps/mpp/paypal-and-your-data?ver=email-text';

export const GB_APR = '19.9';
